import * as types from './mutation_types';

export default {
  [types.UPDATE_API](state, apiObject) {
    state.api = apiObject;
  },
  [types.ADD_API](state, nameValueObj) {
    state.api[nameValueObj.name] = nameValueObj.value;
  },
  [types.SET_ASSETS_ROOT](state, assetsRoot) {
    state.assetsRoot = assetsRoot;
  },
  [types.SET_API_KEYS](state, apiKeys) {
    state.apiKeys = apiKeys;
  }
}